$('[expandTextControl]').on('click', function () {
    $(this).parent().find('[expandTextFull]').slideToggle('slow');
    var $this = $(this);
    $this.toggleClass('open');

    if ($this.hasClass('open')) {
        $this.find('.inner--hover').html($this.attr('less'));
    } else {
        $this.find('.inner--hover').html($this.attr('more'));
    }
});





/**
 * Banbner Popup Logic
 */

jQuery(document).ready(function () {
    var modalCookie = getCookie('modal');

    // Get the current date
    var today = new Date();
    var currentMonth = today.getMonth() + 1; // getMonth() is zero-based, so add 1

    // Check if the current month is between September (9) and December (12)
    if (currentMonth >= 9 && currentMonth <= 12) {
        if (jQuery("#popup").length) {
            if (modalCookie != 1) {
                if (jQuery(".popup--position--center")[0]) {
                    jQuery('html').addClass('popup--html');

                    jQuery(".popup--pop-up").fadeIn(1000);
    
                    jQuery('main').addClass('popup--body');
    
                    // Trigger the color change after a short delay to ensure the transition takes effect
                    setTimeout(function () {
                      jQuery('.popup--body').addClass('bg-animation');
                    }, 100);
                    
                }

              



                jQuery(".popup--close-button, .popup--close-btn").click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    jQuery(".popup--pop-up").hide();

                    // Set the cookie to prevent showing for 1 day
                    var mydate = new Date();
                    var m = 1440; // 1 day in minutes
                    mydate.setTime(mydate.getTime() + (m * 60 * 1000));
                    document.cookie = 'modal=1;expires=' + mydate.toUTCString() + ';path=/';
                    
                    jQuery('main').removeClass('popup--body');
                    jQuery('main').removeClass('bg-animation');
                    jQuery('html').removeClass('popup--html');
   

                    return false;
                });

               
                jQuery(".popup--link").click(function (e) {
                    jQuery(".popup--pop-up").fadeOut(700);

                    // Set the cookie to prevent showing for 1 day
                    var mydate = new Date();
                    var m = 1440; // 1 day in minutes
                    mydate.setTime(mydate.getTime() + (m * 60 * 1000));
                    document.cookie = 'modal=1;expires=' + mydate.toUTCString() + ';path=/';
                });
            }
        }
    }


//open modal on banner click
   
jQuery(".popup--close-button, .popup--close-btn").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    jQuery(".popup--pop-up").hide();

    // Set the cookie to prevent showing for 1 day
    var mydate = new Date();
    var m = 1440; // 1 day in minutes
    mydate.setTime(mydate.getTime() + (m * 60 * 1000));
    document.cookie = 'modal=1;expires=' + mydate.toUTCString() + ';path=/';
    
    jQuery('main').removeClass('popup--body');
    jQuery('main').removeClass('bg-animation');
    jQuery('html').removeClass('popup--html');

    return false;
});
    jQuery("#banner-open-popup").click(function (e) {
       
        e.preventDefault();
        if (jQuery(".popup--position--center")[0]) {
            jQuery('html').addClass('popup--html');
            jQuery('main').addClass('popup--body');

            // Trigger the color change after a short delay to ensure the transition takes effect
            setTimeout(function () {
              jQuery('.popup--body').addClass('bg-animation');
            }, 100);
            
            
        }
    
        jQuery('#popup').insertBefore(jQuery('.stage'));
       
        
        jQuery(".popup--pop-up").fadeIn(700);
    });
});

function getCookie(c_name) {
    var i, x, y, ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
            return unescape(y);
        }
    }
}

